var map = {
	"./en.json": [
		924,
		0
	],
	"./ja.json": [
		926,
		6
	],
	"./ko.json": [
		927,
		7
	],
	"./zh-CN.json": [
		928,
		8
	],
	"./zh-TW.json": [
		929,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 918;
module.exports = webpackAsyncContext;